module.exports = __webpack_public_path__ + "static/media/9.4eddd798.jpg";